import Brands from '@/enums/Brands';
import { CONTACTS_US_EMAIL, CONTACTS_US_URL, TERM_AND_CONDITIONS_URL } from './static';

const FOOTER_BASE_DATA = {
	MP: {
		companyName: 'MP Pumps',
		telephone: '800-563-8006',
		email: '',
		contactFormLink: '',
		aboutUsLink: 'https://www.mppumps.com/en-us/about-us',
		downloadCenter: 'https://www.mppumps.com/en-us/downloads',
		website: 'https://www.mppumps.com',
		privacyPolicy: 'https://www.irco.com/en-us/terms',
		termsAndConditions: '',
		socials: {
			x: 'https://x.com/mppumps',
			youtube: 'https://www.youtube.com/@Mppumps',
			linkedin: 'https://www.linkedin.com/company/mp-pumps',
			facebook: 'https://www.facebook.com/mp.pumps.9',
			instagram: '',
		},
		partnerLogos: [],
	},
	OB: {
		companyName: 'Oberdorfer',
		telephone: '800-448-1668',
		email: '',
		contactFormLink: '',
		aboutUsLink: 'https://www.oberdorferpumps.com/en-us/about-us',
		downloadCenter: 'https://www.oberdorferpumps.com/en-us/about-us/download-center',
		website: 'https://www.oberdorferpumps.com',
		privacyPolicy: 'https://www.irco.com/en-us/terms',
		termsAndConditions: '',
		socials: {
			x: '',
			youtube: '',
			linkedin: 'https://www.linkedin.com/company/oberdorfer-pumps',
			facebook: '',
			instagram: '',
		},
		partnerLogos: [],
	},
	MR: {
		companyName: 'Ingersoll Rand Partner Store',
		telephone: '800-448-1668',
		email: '',
		contactFormLink: '',
		aboutUsLink: 'https://www.miltonroy.com/en-us/about-us',
		downloadCenter: 'https://www.miltonroy.com/en-us/',
		website: 'https://www.miltonroy.com/en-us',
		privacyPolicy: 'https://www.irco.com/en-us/terms',
		termsAndConditions: '',
		socials: {
			x: '',
			youtube: '',
			linkedin: '',
			facebook: '',
			instagram: '',
		},
		partnerLogos: [
			{
				name: 'Milton Roy',
				src: '/partner_logos/logo_MR_white.svg',
				desktopHeight: 35,
				desktopWidth: 285,
				mobileHeight: 18,
				mobileWidth: 142,
			},
			{
				name: 'Albin Pump',
				src: '/partner_logos/logo_ALBIN_PUMP_white.svg',
				desktopHeight: 57,
				desktopWidth: 157,
				mobileHeight: 32,
				mobileWidth: 85,
			},
			{
				name: 'LMI',
				src: '/partner_logos/logo_LMI_white.svg',
				desktopHeight: 35,
				desktopWidth: 110,
				mobileHeight: 18,
				mobileWidth: 56,
			},
			{
				name: 'Hartell',
				src: '/partner_logos/logo_HARTELL_white.svg',
				desktopHeight: 29,
				desktopWidth: 192,
				mobileHeight: 16,
				mobileWidth: 104,
			},
			{
				name: 'Williams Pumps',
				src: '/partner_logos/logo_WILLIAMS_white.svg',
				desktopHeight: 39,
				desktopWidth: 180,
				mobileHeight: 21,
				mobileWidth: 95,
			},
			{
				name: 'YT Systems',
				src: '/partner_logos/logo_YZ_white.svg',
				desktopHeight: 33,
				desktopWidth: 61,
				mobileHeight: 21,
				mobileWidth: 37,
			},
		],
	},
	ARO: {
		companyName: 'ARO',
		telephone: '+353 1 870 7126',
		email: '',
		contactFormLink: '',
		aboutUsLink: 'https://www.arozone.com/en/about-aro',
		downloadCenter: 'https://www.arozone.com/en/tools/document-library',
		website: 'https://www.arozone.com/',
		privacyPolicy: 'https://www.irco.com/en-us/terms',
		termsAndConditions: '',
		socials: {
			x: '',
			youtube: 'https://www.youtube.com/@aropumps',
			linkedin: 'https://www.linkedin.com/company/aro-fluid-management',
			facebook: 'https://www.facebook.com/aropumps/',
			instagram: '',
		},
		partnerLogos: [],
	},
	'ILC-US': {
		companyName: 'ILC Dover',
		telephone: '1.800.631.9567',
		email: '',
		contactFormLink: '',
		aboutUsLink: 'https://www.ilcdover.com/en/company/',
		downloadCenter: 'https://www.ilcdover.com/en/resources/',
		website: 'https://www.ilcdover.com/en/',
		privacyPolicy: 'https://www.irco.com/en-us/terms',
		termsAndConditions: '',
		socials: {
			x: 'https://x.com/ILCDover',
			youtube: 'https://www.youtube.com/user/ILCDoverLP',
			linkedin: 'https://www.linkedin.com/company/ilc-dover',
			facebook: 'https://www.facebook.com/ILCDover/',
			instagram: '',
		},
		partnerLogos: [],
	},
	'WV-US': {
		companyName: 'Welch',
		telephone: '847-676-8800',
		email: '',
		contactFormLink: '',
		aboutUsLink: 'https://www.welchvacuum.com/en-us/about-us',
		downloadCenter: 'https://www.welchvacuum.com/en-us/about-us/downloads',
		website: 'https://www.welchvacuum.com/en-us/',
		privacyPolicy: 'https://www.irco.com/en-us/terms',
		termsAndConditions: '',
		socials: {
			x: '',
			youtube: 'https://www.youtube.com/channel/UCUQOjkmDMJG__K1n6L_jiOQ',
			linkedin: 'https://www.linkedin.com/company/99924698',
			facebook: '',
			instagram: '',
		},
		partnerLogos: [],
	},
	DT: {
		companyName: 'Dosatron',
		telephone: '1-727-443-5404 ',
		email: 'mailbox@dosatronusa.com',
		contactFormLink: 'https://www.dosatron.com/en-us/modals/contact',
		aboutUsLink: 'https://www.dosatron.com/en-nam/about-us-na',
		downloadCenter: 'https://www.dosatron.com/en-us/resources',
		website: 'https://www.dosatron.com/en-us',
		privacyPolicy:
			'https://azure-na-assets.contentstack.com/v3/assets/blt2f5f8d12e26902ce/blt74b142dbf4913884/68ac84f591cf8d11b5827ec9/Dosatron_Privacy_Policy.pdf',
		termsAndConditions: '',
		socials: {
			x: '', // They deliberately do not want to link their X account
			youtube: 'https://www.youtube.com/@DosatronIntl',
			linkedin: 'https://www.linkedin.com/company/dosatron-international-llc/',
			facebook: 'https://www.facebook.com/Dosatronusa',
			instagram: 'https://www.instagram.com/dosatronusa',
		},
		partnerLogos: [],
	},
	'ARO-NA': {
		companyName: 'ARO NA',
		telephone: '+1 800 495 0276',
		email: '',
		contactFormLink: 'https://www.arozone.com/en/contact/',
		aboutUsLink: 'https://www.arozone.com/en/about-aro/',
		downloadCenter: 'https://www.arozone.com/en/tools/document-library/',
		website: 'https://www.arozone.com/en/',
		privacyPolicy: 'https://www.irco.com/en/terms/',
		termsAndConditions: '',
		socials: {
			x: '',
			youtube: 'https://www.youtube.com/user/aropumps',
			linkedin: 'https://www.linkedin.com/company/aro-fluid-management/',
			facebook: 'https://www.facebook.com/aropumps/',
			instagram: 'https://www.instagram.com/arofluidmanagement/',
		},
		partnerLogos: [],
	},
};

export const FOOTER = Object.fromEntries(
	Object.entries(FOOTER_BASE_DATA).map(([brandCode, baseData]) => [
		brandCode,
		{
			...baseData,
			email: CONTACTS_US_EMAIL[brandCode as keyof typeof CONTACTS_US_EMAIL],
			contactFormLink: CONTACTS_US_URL[brandCode as keyof typeof CONTACTS_US_URL],
			termsAndConditions: TERM_AND_CONDITIONS_URL[brandCode as Brands],
		},
	]),
);
